import script from "./Users.vue?vue&type=script&setup=true&lang=ts"
export * from "./Users.vue?vue&type=script&setup=true&lang=ts"

import "./Users.vue?vue&type=style&index=0&id=136c0d5f&lang=css"

const __exports__ = script;

export default __exports__